import { connect } from 'react-redux';

import AvatarEditorModal from '../../components/AccountSettings/MyProfile/AvatarEditor/AvatarEditorView';

const mapStateToProps = (state) => ({});

const AccountSettingsContainer = connect(
  mapStateToProps,
  null,
)(AvatarEditorModal);

export default AccountSettingsContainer;
